
const stats = {
  // Statistics
  stats: {
    matchHistory: "Match History",
    h2hMatches: "H2H Matches",
    homeLastGames: "Home Last Games",
    awayLastGames: "Away Last Games",
    date: "Date",
    score: "Score",
    competition: "Competition",
    noDataText: "No data available",
    lastGamesNotAvailable: "Last games not available",
    h2h: "Head to Head",
    wins: "Wins",
    draws: "Draws",
    losses: "Losses",
    home: "Home",
    away: "Away",
    homeTeam: "Home Team",
    awayTeam: "Away Team",
    result: "Result",
    homeTeamWins: "Home Team Wins",
    awayTeamWins: "Away Team Wins",
    lastMatches: "Last {count} matches",
    versus: "VS",
    notAvailable: "Not Available",
    goals: "Goals",
    total: "Total",
    label: "Label",
    goalsForLabel: "Goals For",
    goalsAgainstLabel: "Goals Against",
    totalGames: "Total Games",
    homeGames: "Home Games", 
    awayGames: "Away Games",
    totalWins: "Total Wins",
    homeWins: "Home Wins",
    awayWins: "Away Wins",
    totalDraws: "Total Draws",
    homeDraws: "Home Draws", 
    awayDraws: "Away Draws",
    totalLosses: "Total Losses",
    homeLosses: "Home Losses",
    awayLosses: "Away Losses",
    goalsScored: {
      total: "Goals Scored (Total)",
      home: "Goals Scored (Home)",
      away: "Goals Scored (Away)", 
      label: "Goals Scored"
    },
    goalsConceded: {
      total: "Goals Conceded (Total)",
      home: "Goals Conceded (Home)",
      away: "Goals Conceded (Away)",
      label: "Goals Conceded"
    },
    goalsAverage: {
      total: "Goals Average (Total)"
    },
    goalsConcededAverage: {
      total: "Goals Conceded Average (Total)"
    }
  }
};

export default stats;
